import { HintArrowView } from '../../../views/hints/HintArrowView';

export class TutorialHintArrowView extends HintArrowView {
  private animationTime = 0;

  public reset(): this {
    super.reset();
    this.animationTime = 0;
    return this;
  }

  public update(deltaTime: number): void {
    this.animationTime += deltaTime;
    this.updateOffset(Math.sin(this.animationTime * 0.1 + 1) / 2);
  }
}
